// stayai-pdp-kaching-integration.js
(function() {
  'use strict';

  const SELECTORS = {
    ATC_BTN: "form.shopify-product-form[action='/cart/add'] buy-buttons[form] button.button[type='submit']",
    KACHING_BLOCK: "kaching-bundles-block",
    STAYAI_WIDGET: `purchase-options[id^="stayai-subscription-widget-"]`
  };
  // Helper: Wait for element to appear in DOM
  function elementReady(selector) {
    return new Promise((resolve) => {
      const el = document.querySelector(selector);
      if (el) {
        resolve(el);
        return; // Early return - no observer needed
      }

      // Create observer only if element not found immediately
      const observer = new MutationObserver((mutationRecords, obs) => {
        const foundElement = document.querySelector(selector);
        if (foundElement) {
          resolve(foundElement);
          obs.disconnect(); // Clean up
        }
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    });
  }

  // Initialize integration when StayAI widget is ready
  async function initKachingIntegration() {
    try {
      // Wait for StayAI widget to appear
      const stayAIWidget = await elementReady(SELECTORS.STAYAI_WIDGET);

      // Enable external pricing mode - this bypasses updateProductPrice() calls
      stayAIWidget.setUseExternalPricing(true);

      // Helper function to extract and normalize pricing data from Kaching event
      function extractPricingData(eventDetail) {
        if (!eventDetail || !eventDetail.pricing) return null;

        const pricing = eventDetail.pricing;
        const variantIdQuantities = eventDetail.variantIdQuantities;
        const first_vairantIdQuantiy = (Array.isArray(variantIdQuantities) && variantIdQuantities.length > 0)
          ? variantIdQuantities[0]
          : null;

        let discountedPrice = pricing?.discountedPrice ?? null;
        let discountedPricePerItem = pricing?.discountedPricePerItem ?? null;
        let fullPrice = pricing?.fullPrice ?? null;
        let fullPricePerItem = pricing?.fullPricePerItem ?? null;
        let vairantIdQuantiy = first_vairantIdQuantiy;

        // Calculate the kaching discount percentage (0.xx format) to sync with shopify cart+checkout pricing calculations
        let full = Number(fullPricePerItem?.amount);
        let discounted = Number(discountedPricePerItem?.amount);
        let canCompute = full !== 0 && !isNaN(discounted) && !isNaN(full);
        let kachingDiscountPercentage = canCompute ? 1 - (discounted / full) : 0;
        let kachingDiscountPercentageRounded = Number(kachingDiscountPercentage).toFixed(2);
        return { discountedPrice, discountedPricePerItem, fullPrice, fullPricePerItem, vairantIdQuantiy, kachingDiscountPercentageRounded };
      }

      // Listen for Kaching variants-changed event and update StayAI prices
      document.addEventListener('variants-changed', function(event) {
        if (event.detail && event.detail.pricing) {

          // Extract pricing data and update StayAI prices
          const pricingData = extractPricingData(event.detail);
          if (pricingData) {
            stayAIWidget.updatePricesFromExternal(pricingData);
          }
        }
      });

    } catch (error) {
      console.error('[StayAI-Kaching] Integration failed:', error);
    }
  }

  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKachingIntegration);
  } else {
    initKachingIntegration();
  }
})();